$(function () {

	/**
	 * メインビジュアルのタイトルアニメーションを設定
	 */
	gsap.fromTo(".mv__title", {
		y: 10,
		opacity: 0,
	}, {
		y: 0,
		opacity: 1,
		duration: 1.2,
		ease: "power3.out",
		delay: 0.5
	});

	$(".mv-slider").on("init", function () {
		$(this).addClass('active');
		$('.slick-slide[data-slick-index="0"]').addClass("add-animation");
	}).slick({
		dots: true,
		arrows: false,
		infinite: true,
		fade: true,
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 5000,
		slidesToShow: 1,
		slidesToScroll: 1,
		pauseOnHover: false,
		pauseOnFocus: false,
		pauseOnDotsHover: false,
		slide: '.mv-slider__item',
	})
		.on({
			beforeChange: function (event, slick, currentSlide, nextSlide) {
				$(".slick-slide", this).eq(nextSlide).addClass("add-animation");
				$(".slick-slide", this).eq(currentSlide).addClass("remove-animation");
			},
			afterChange: function () {
				$(".remove-animation", this).removeClass(
					"remove-animation add-animation"
				);
			},
		});

	$('.pickup .pickup-post-list').slick({
		slide: '.pickup-post-list__item',
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		speed: 600,
		centerMode: false,
		centerPadding: '0',
		dots: false,
		arrows: true,
		draggable: true,
		adaptiveHeight: false,
		swipe: true,
		fade: false,
		responsive: [{
			breakpoint: 1025,
			settings: {
				centerMode: true,
				slidesToShow: 3,
				centerPadding: '40px',
			}
		},
		{
			breakpoint: 667,
			settings: {
				centerMode: true,
				slidesToShow: 1,
				centerPadding: '25px',
			}
		}
		]
	});

	$('.exclusive-list').slick({
		slide: '.exclusive-list__item',
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		speed: 600,
		centerMode: false,
		centerPadding: '0',
		dots: false,
		arrows: true,
		draggable: true,
		adaptiveHeight: false,
		swipe: true,
		fade: false,
		responsive: [{
			breakpoint: 1025,
			settings: {
				centerMode: true,
				slidesToShow: 3,
				centerPadding: '48px',
			}
		},
		{
			breakpoint: 667,
			settings: {
				centerMode: true,
				slidesToShow: 1,
				centerPadding: '35px',
			}
		}
		]
	});

	$('.onlineshop-list').slick({
		slide: '.onlineshop-list__item',
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		speed: 600,
		centerMode: false,
		centerPadding: '0',
		dots: false,
		arrows: true,
		draggable: true,
		adaptiveHeight: false,
		swipe: true,
		fade: false,
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev slick-arrow--red">前へ</button>',
		nextArrow: '<button type="button" class="slick-next slick-arrow--red">次へ</button>',
		responsive: [{
			breakpoint: 1025,
			settings: {
				centerMode: true,
				slidesToShow: 3,
				centerPadding: '40px',
			}
		},
		{
			breakpoint: 667,
			settings: {
				centerMode: true,
				slidesToShow: 1,
				centerPadding: '25px',
			}
		}
		]
	});

	$('.header__btn').click(function () {
		$(this).toggleClass('active');
		$('.header__nav,body').toggleClass('active');
	});

	$('.header a').click(function () {
		$('.header__btn,.header__nav,body').removeClass('active');
	});

	const hostname = window.location.hostname;
	console.log(hostname);
	$('a[href^="http"]:not([href*="' + hostname + '"])').each(function () {
		$(this).attr({
			target: '_blank',
			rel: 'noopener noreferrer'
		});

		$(this).addClass('is-external');
	});

	gsap.registerPlugin(ScrollTrigger);

	gsap.to('.header', {
		scrollTrigger: {
			trigger: 'body',
			start: '200 top',
			toggleClass: { targets: '.header', className: 'header--fixed' },
			invalidateOnRefresh: true,
			//markers: true,
		}
	});


	/**
	 * オンラインショップの流れるテキストアニメーションの速度を設定
	 */
	$('.onlineshop-post__desc').each(function () {
		const $this = $(this);
		const $desc = $this.find('div');
		const textLength = Math.max($desc[0].textContent.length, 18);
		$desc[0].style.animationDuration = (textLength) + 's';
		$desc[0].style.animationDelay = (textLength * -0.5) + 's';
		$desc[1].style.animationDuration = (textLength) + 's';
	});


	let isLoading = false;

	ScrollTrigger.create({
		trigger: "#load-more-trigger",
		start: "top bottom", // トリガーが画面下端に入ったら
		onEnter: () => {
			if (isLoading || wp_api_settings.current_page >= wp_api_settings.max_pages) return;

			isLoading = true;
			document.querySelector('.loader').style.display = 'block';

			const formData = new FormData();
			formData.append('action', 'load_more');
			formData.append('page', wp_api_settings.current_page);

			fetch(wp_api_settings.ajax_url, {
				method: 'POST',
				body: formData
			})
				.then(response => response.text())
				.then(data => {
					if (data) {
						document.getElementById('post-container').insertAdjacentHTML('beforeend', data);
						wp_api_settings.current_page++;
						isLoading = false;
						document.querySelector('.loader').style.display = 'none';

						// 新しく追加された要素のためにScrollTriggerをリフレッシュ
						ScrollTrigger.refresh();
					}
				});
		}
	});

	if (window.matchMedia("(min-width: 1025px)").matches) {

		gsap.registerPlugin(ScrollTrigger);

		ScrollTrigger.create({
			trigger: ".bnr-list",
			start: "top 110px",
			end: () => {
				const mainBottom = document.querySelector('.main').getBoundingClientRect().bottom + window.pageYOffset;
				const bnrHeight = document.querySelector('.bnr-list').offsetHeight;
				return `+=${mainBottom - (window.pageYOffset + document.querySelector('.bnr-list').getBoundingClientRect().top) - bnrHeight - 40}`;
			},
			pin: true,                 // trigger要素(.bnr-list)を固定
			pinSpacing: false,
			invalidateOnRefresh: true, // リサイズ時に再計算
			// markers: true,          // 確認用
		});
	}


});
